export default function setAgentMapViewValue({ state }, mapViewKey, mapViewValue) {
  state.set(['agentMapView', mapViewKey], mapViewValue);
}
